<template>
    <div class="md:px-0">
        <div class="bg-ap-fs-primary py-4 text-2xl text-white px-3 md:px-6">
            Your Booking Summary
        </div>

        <div class="bg-white px-8 py-4 border-b-2 border-gray-300 border-opacity-70">
            <div class="grid grid-cols-2 flex-shrink-0 gap-4">
                <div class="col-span-4 md:col-span-2">
                    <span class="font-bold text-lg">Dates</span>
                    <div class="grid grid-cols-2 gap-6 mt-5">
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Departure Date</p>
                            <span>{{ formatDate(entry) }}</span>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Time</p>
                            <span>{{ formatTime(entry) }}</span>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Return Date</p>
                            <span>{{ formatDate(exit) }}</span>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Time</p>
                            <span>{{ formatTime(exit) }}</span>
                        </div>
                    </div>

                    <div class="mt-5"></div>
                    <hr>
                    <div class="mt-5"></div>
                    <span class="font-bold text-lg">Booking Details </span>

                    <div v-for="(vehicle) in vehicles" :key="vehicle.registration" class="mt-3">
                        <div v-if="vehicle.type != null" class="capitalize">

                            <span class="pl-5 block text-sm">{{ vehicle.registration }}</span>
                            <span class="pl-5 block text-sm" v-if="vehicle.partySize">{{ vehicle.partySize }} passengers</span>
                            <div v-if="vehicle.valet" class="pl-5">
                                + {{ vehicle.valet.name }} - {{ $filters.money(adjustedTotal ?? 0) }}
                            </div>
                        </div>
                    </div>

                    <div class="mb-5"></div>
                    <hr>

                    <div class="my-5 md:col-span-2 text-2xl font-semibold">
                        <p class="text-xs uppercase font-bold">Total</p>
                        <span v-if="originalTotal" class="text-3xl line-through">{{ $filters.money(originalTotal) }}</span>
                        <span class="text-3xl text-brand-blue" :class="{'text-red-500' : originalTotal}">{{ $filters.money(adjustedTotal ?? 0) }}</span>
                    </div>

                    <hr v-if="showSaveBtn">

                    <div class="mt-8 px-8 md:px-0" v-if="showSaveBtn">
                        <button :disabled="incomplete"

                                :class="(incomplete) ? 'bg-gray-200 text-gray-400 cursor-default' : 'bg-brand-blue text-white'"
                                class="border-2 rounded-lg w-full md:w-auto text-xl px-12 py-2 uppercase  tracking-wider">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
export default {
    computed: {
        adjustedTotal() {
            return this.newTotal;
        },
    },
    methods: {
        formatDate(date) {
            const months = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ];

            const monthIndex = date.getMonth();
            const monthName = months[monthIndex];

            return `${date.getDate()} ${monthName} ${date.getFullYear()}`;
        },
        formatTime(date) {
            const hours = (`0${date.getHours()}`).slice(-2);
            const minutes = (`0${date.getMinutes()}`).slice(-2);

            return `${hours}:${minutes}`;
        },
    },
    props: {
        carpark: { required: true },
        entry: { required: true },
        exit: { required: true },
        vehicles: { default: [] },
        showSaveBtn: { default: false },
        newTotal: { required: true },
        total: { required: true },
        originalTotal: { required: false, default: null },
        product: { required: true },
    },
    mounted() {
    },
};
</script>

